var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flyout-cart",
      attrs: { "aria-hidden": _vm.isOpen ? "false" : "true" }
    },
    [
      _c("header", { staticClass: "flyout-cart-header" }, [
        _c("h3", { staticClass: "flyout-cart-header-title" }, [
          _vm._v("\n      " + _vm._s(_vm.translations.yourCart) + "\n    ")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "flyout-cart-close",
            attrs: { "aria-label": _vm.translations.closeCart },
            on: {
              click: function($event) {
                return _vm.toggleOpen(false)
              }
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "icon-close",
                attrs: { "aria-hidden": "true", viewBox: "0 0 20 20" }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M10 8.586l-7.071-7.071-1.414 1.414 7.071 7.071-7.071 7.071 1.414 1.414 7.071-7.071 7.071 7.071 1.414-1.414-7.071-7.071 7.071-7.071-1.414-1.414-7.071 7.071z"
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flyout-cart-line-items" },
        [
          _vm._l(_vm.items, function(item) {
            return _c(
              "LineItem",
              _vm._b(
                {
                  key: item.key,
                  attrs: {
                    "money-format": _vm.moneyFormat,
                    translations: _vm.translations.lineItem
                  },
                  on: {
                    update: function($event) {
                      return _vm.updateItem({ item: item, quantity: $event })
                    },
                    remove: function($event) {
                      return _vm.removeItem({ item: item })
                    }
                  }
                },
                "LineItem",
                item,
                false
              )
            )
          }),
          _vm._v(" "),
          _vm.isEmpty
            ? _c("span", { staticClass: "flyout-cart-empty" }, [
                _vm._v("\n      " + _vm._s(_vm.translations.isEmpty) + "\n    ")
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("footer", { staticClass: "flyout-cart-footer" }, [
        _c("div", { staticClass: "flyout-cart-footer-table-row" }, [
          _c("span", { staticClass: "flyout-cart-footer-table-row-text" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.translations.subTotal) + "\n      "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "flyout-cart-footer-table-row-figure" }, [
            _vm._v("\n        " + _vm._s(_vm.formattedSubTotal) + "\n      ")
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "flyout-cart-footer-small-text" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.translations.subTotalSmallPrint) + "\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "flyout-cart-button button-primary",
            on: { click: _vm.checkout }
          },
          [_vm._v("\n      " + _vm._s(_vm.translations.checkout) + "\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }